module.exports = "/images/bankbajio.svg?1e04310eac11ed6ebc43dd2d2f6b48d1";